/**
 * Size formatting of the Assets panel (W2-10 projects-data): 1024-based units as messages, locale digits.
 */

import type { MessageKey } from '../../i18n/types';
import { m } from './assets.messages';

const SIZE_UNITS: readonly MessageKey[] = [m.sizeB, m.sizeKB, m.sizeMB, m.sizeGB, m.sizeTB];

export interface SizeText {
  readonly locale: string;
  readonly t: (key: MessageKey, params?: Readonly<Record<string, string | number>>) => string;
}

/** "0 B", "12 KB", "3.4 MB". */
export function formatBytes(bytes: number, text: SizeText): string {
  let v = Number.isFinite(bytes) && bytes > 0 ? bytes : 0;
  let unit = 0;
  while (v >= 1024 && unit < SIZE_UNITS.length - 1) {
    v /= 1024;
    unit++;
  }
  const digits = unit === 0 ? 0 : v < 10 ? 1 : 0;
  const size = new Intl.NumberFormat(text.locale, { maximumFractionDigits: digits }).format(v);
  return text.t(SIZE_UNITS[unit] ?? m.sizeB, { size });
}
